import { createAction } from "@reduxjs/toolkit";
import type { CreateBalanceAdjustmentBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const createBalanceAdjustment = createApiThunk<string, CreateBalanceAdjustmentBody>(
  "balanceAdjustments/createBalanceAdjustment",
  async (balanceAdjustment: CreateBalanceAdjustmentBody, { extra: { adminRepository } }) => {
    return adminRepository!.createBalanceAdjustment(balanceAdjustment);
  },
);

export const resetCreateBalanceAdjustment = createAction("balanceAdjustments/resetCreateBalanceAdjustment");
